"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputConsumer = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _InputContext = require("../InputContext");

var InputConsumer = function InputConsumer(props) {
  if (typeof props.children !== 'function') {
    throw new Error("child of ".concat(props.consumerCompName, " must be a context consumer function"));
  }

  return /*#__PURE__*/_react["default"].createElement(_InputContext.InputContext.Consumer, null, function (context) {
    if (!context) {
      throw new Error("".concat(props.consumerCompName, " cannot be rendered outside the Input component"));
    }

    return props.children(context);
  });
};

exports.InputConsumer = InputConsumer;
InputConsumer.propTypes = {
  children: _propTypes["default"].any.isRequired,
  consumerCompName: _propTypes["default"].string
};
InputConsumer.defaultProps = {
  consumerCompName: 'InputConsumer'
};